import type { SurveyConfigBlock, SurveyConfigBlockGroup } from '@highlight-cp/project-api';

export const VALIDATION_ERROR_TYPE = {
  PREVIEW: 'PREVIEW',
  STATUS: 'STATUS',
  MATERIALIZE: 'MATERIALIZE',
} as const;

export interface SurveyConfigBlockDisplay {
  isExpanded: boolean;
}

export interface SurveyBundleDisplay {
  isExpanded: boolean;
}

type SurveyConfigBlockDisplayMap = Record<string, Record<string, SurveyConfigBlockDisplay>>;
type SurveyBundleDisplayMap = Record<string, Record<string, SurveyBundleDisplay>>;

type SurveyConfigBlocksSelectionMap = Record<string, string[]>;
type SurveyConfigBlockGroupsSelectionMap = Record<string, string[]>;
type SurveyConfigBlockGroupsDeletionMap = Record<string, string[]>;

export type ValidationErrorType = keyof typeof VALIDATION_ERROR_TYPE;

export interface ValidationError {
  hasError: boolean;
  validationErrorType: ValidationErrorType | null;
}

export interface SurveyDesignerSlice {
  activeBlockEditorTab: string | null;
  activeSurveyConfigBlock: SurveyConfigBlock | null;
  activeSurveyConfigBlockGroup: SurveyConfigBlockGroup | null;
  deletingSurveyConfigBlockGroupIds: SurveyConfigBlockGroupsDeletionMap;
  invalidSurveyConfigBlocks: SurveyConfigBlock[];
  inputFocus: string | null;
  isBulkActionsMenuOpen: boolean;
  isDirectBlueprintReset: boolean;
  isProjectLocked: boolean;
  isSurveyConfigValid: boolean;
  isSkipLogicLoading: boolean;
  orderedSurveyConfigBlocks: SurveyConfigBlock[];
  projectId: number | null;
  scrollToSurveyConfigBlockId: string | null;
  solutionId: string | null;
  surveyBundlesDisplay: SurveyBundleDisplayMap;
  surveyConfigBlocksDisplay: SurveyConfigBlockDisplayMap;
  surveyConfigBlocksSelection: SurveyConfigBlocksSelectionMap;
  surveyConfigBlockGroupsSelection: SurveyConfigBlockGroupsSelectionMap;
  validationError: ValidationError;
}
